// removed by extract-text-webpack-plugin
module.exports = {"normal":"normalReportTip_normal_35BY-","normalTitle":"normalReportTip_normalTitle_3KA3d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/normalReportTip/normalReportTip.scss
// module id = 1528
// module chunks = 0